// extracted by mini-css-extract-plugin
export var addButton = "_dw-0";
export var border = "_dw-8";
export var check = "_dw-h";
export var danger = "_dw-6";
export var dropdownContainer = "_dw-1";
export var editModalBody = "_dw-j";
export var footerContainer = "_dw-i";
export var fullWidth = "_dw-a";
export var hide = "_dw-9";
export var icon = "_dw-3";
export var input = "_dw-7";
export var inputFlex = "_dw-b";
export var inputWrapper = "_dw-c";
export var manualFocus = "_dw-5";
export var optionButton = "_dw-4";
export var pillWrapper = "_dw-e";
export var pointer = "_dw-2";
export var showOverflow = "_dw-f";
export var tagsFlex = "_dw-d";
export var xButton = "_dw-g";